import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { Routes } from '~/constants/routes';
import { QueryParamNames } from '~/constants/search';

/**
 * Navigates to a collection share link's edit surface: the showcase editor hosted by the showcases
 * page. Single owner of that destination so the collection-link toasts' Edit buttons can't drift.
 */
export const useNavigateToShowcaseEdit = () => {
  const router = useRouter();

  const navigateToShowcaseEdit = useCallback(
    (collectionId: string) => {
      void router.push({ pathname: Routes.showcases, query: { [QueryParamNames.Showcase]: collectionId } });
    },
    [router],
  );

  return { navigateToShowcaseEdit };
};
